import React, {Component} from 'react';
import Formsy from 'formsy-react';
import { FormsyText } from 'formsy-material-ui/lib';
import FlatButton from 'material-ui/FlatButton';

class ContactForm extends Component {

  props: Props;

  state: {
    canSubmit: boolean;
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      canSubmit: false,
      type: '',
      message: '',
    };
  }
  enableButton = () => {
    if (!this.state.canSubmit) {
      this.setState({canSubmit: true});
    }
  }

  disableButton = () => {
    if (this.state.canSubmit) {
      this.setState({canSubmit: false});
    }
  }

  notifyFormError = (data: Object) => {
    console.error('Form error:', data);
  }

  handleSubmit = (data: Object) => {
    // Send the form data.
    var xmlhttp = new XMLHttpRequest();
    var _this = this;
    xmlhttp.onreadystatechange = function() {
      if (xmlhttp.readyState === 4) {
        var response = JSON.parse(xmlhttp.responseText);
          if (xmlhttp.status === 200 && response.status === 'OK') {
            _this.setState({ type: 'success', message: 'We have received your message and will get in touch shortly. Thanks!' });
          }
          else {
            _this.setState({ type: 'danger', message: 'Sorry, there has been an error. Please try again later or send us an email at info@prece.it.' });
          }
        }
      };
      xmlhttp.open('POST', 'sendmail', true);
      xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xmlhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xmlhttp.send(this.requestBuildQueryString(data));
  }

  /**
   * Transforms an object into a URL querystring.
   *
   * @param object params
   * @return string the formatted querystring.
   */
  requestBuildQueryString = (params) => {
    var queryString = [];
    for(var property in params)
      if (params.hasOwnProperty(property)) {
        queryString.push(encodeURIComponent(property) + '=' + encodeURIComponent(params[property]));
      }
    return queryString.join('&');
  }

  render() {
    const message = this.state.message;
    if (message.length > 0) {
      return (
        <div>
          {this.state.message}
        </div>
      );
    } else {
      return (
          <Formsy.Form
          onValid={this.enableButton}
          onInvalid={this.disableButton}
          onValidSubmit={this.handleSubmit}
          onInvalidSubmit={this.notifyFormError}
          >
            <FormsyText
              name="name"
              floatingLabelText="Name"
              fullWidth={true}
              hintText="Please enter your full name"
              required
            />
            <FormsyText
              name="email"
              fullWidth={true}
              validations="isEmail"
              validationError="The email address you entered is invalid"
              floatingLabelText="Email address"
              hintText="Please enter a valid email address"
              required
            />
            <FormsyText
              name="subject"
              floatingLabelText="Subject"
              hintText="Enter the subject of your feedback"
              fullWidth={true}
            />
            <FormsyText
              name="body"
              fullWidth={true}
              multiLine={true}
              rows={5}
              required
              hintText="Fill this space with your suggestions, praises, criticisms..."
              floatingLabelText="Your feedback"
            />
            <FlatButton
              type="submit"
              label="Send"
              primary={true}
              style={{ position: "absolute", bottom: 8, right: 96 }}
              disabled={!this.state.canSubmit}
            />
          </Formsy.Form>
      );
    }

  }
}

export default ContactForm;



/** WEBPACK FOOTER **
 ** ./src/Components/ContactForm.js
 **/